module.exports = __webpack_public_path__ + "img/img7.f65e4d31.svg";